// gui/src/config/claude.ts

export const CLAUDE_MODELS = {
  // ✅ SUPPORTED MODELS (matches backend claude_config.py):
  // - expert:     claude-sonnet-5   (all plans) ["Whiz" in the UI]
  // - genius:     claude-opus-4-7   (Basic and above)
  // - uncensored: grok/grok-4-1-fast-reasoning (Basic and above)

  // Haiku 4.5 — kept for legacy alias resolution only (not shown in UI)
  HAIKU_4_5: 'claude-haiku-4-5',

  // Sonnet 5 — Expert (all plans)
  CLAUDE_SONNET_5: 'claude-sonnet-5',

  // Legacy Sonnet ID — kept only so old persisted model strings (saved threads,
  // localStorage, cached automations) still compare equal to "Expert" mode.
  // Resolves server-side via backend resolve_claude_model / CLAUDE_MODEL_MAPPINGS.
  CLAUDE_SONNET_4_6: 'claude-sonnet-4-6',

  // Opus 4.7 — Genius (Basic and above)
  CLAUDE_OPUS_4_7: 'claude-opus-4-7',

  // Sonnet 4.5 — kept for compatibility
  CLAUDE_SONNET_4_5: 'claude-sonnet-4-5',

  // Legacy aliases — kept for backward compatibility; resolve via backend resolve_claude_model
  CLAUDE_35_SONNET: 'claude-haiku-4-5',
  BEST: 'claude-haiku-4-5',
  FAST: 'claude-haiku-4-5',
  INSTANT: 'claude-haiku-4-5',
  LEGACY: 'claude-haiku-4-5',
};

// Legacy sentinel — used only to detect stale persisted Haiku spaces and upgrade them to Expert.
export const DEFAULT_CLAUDE_MODEL = 'claude-haiku-4-5';

// ✅ Default model for all plans
export const DEFAULT_EXPERT_MODEL = CLAUDE_MODELS.CLAUDE_SONNET_5;

// ── "Whiz" is the marketing name for the Expert tier. To swap the underlying
// model in the future, change ONLY CLAUDE_MODELS.CLAUDE_SONNET_5 above (plus
// the matching backend alias in claude_config.py) — every UI surface that
// imports WHIZ_MODEL_ID / WHIZ_LABEL below picks up the change automatically.
export const WHIZ_MODEL_ID = DEFAULT_EXPERT_MODEL;
export const WHIZ_LABEL = 'Whiz';
export const WHIZ_MODEL_DISPLAY_NAME = 'Claude Sonnet 5';

// ✅ ONLY SUPPORTED MODELS - matches backend config
export const AVAILABLE_CLAUDE_MODELS = [
  { id: WHIZ_MODEL_ID, name: `${WHIZ_MODEL_DISPLAY_NAME} (${WHIZ_LABEL})` },
  { id: CLAUDE_MODELS.CLAUDE_OPUS_4_7, name: 'Claude Opus 4.7 (Genius — Basic+)' },
];

// Combined list of all available models (Claude + other providers)
import { AVAILABLE_VENICE_MODELS } from './venice';
import { AVAILABLE_GROK_MODELS } from './grok';

export const ALL_AVAILABLE_MODELS = [
  ...AVAILABLE_CLAUDE_MODELS,
  ...AVAILABLE_VENICE_MODELS,
  ...AVAILABLE_GROK_MODELS,
];

